import React from 'react';

import { FormSection } from '@fitinsur/components';
import { EndorsementTypesSection } from '../index';

function RenderSection({
  formikProps,
  formikRef,
  idOperation,
  idOperationParent,
  globalQuestionnaire,
  idDomainOperation
}) {
  return (
    <FormSection
      sectionName="ENDORSEMENT_TYPES"
      formikRef={formikRef}
      values={formikProps.values}
      errors={formikProps.errors}
      setFieldValue={formikProps.setFieldValue}
      setFieldError={formikProps.setFieldError}
      questionnaire={globalQuestionnaire}
      idOperation={idOperation}
      idOperationParent={idOperationParent}
      idDomainOperationFilter={idDomainOperation}
      onQuestionChange={(
        question,
        value,
        questionnaireUpdated,
        setQuestionnaireUpdated,
        setFieldValue
      ) =>
        EndorsementTypesSection.events.handleQuestionChange({
          question,
          value,
          questionnaireUpdated,
          setQuestionnaireUpdated,
          setFieldValue,
          globalQuestionnaire,
        })
      }
    />
  )
}

const components = {
  RenderSection
}

export { components }
